var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_1213_329688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19644 12.7225C0.583757 11.6564 0.583757 10.3436 1.19644 9.27754L5.11242 2.46359C5.7267 1.39472 6.86294 0.736927 8.09179 0.736927L15.9082 0.736927C17.1371 0.736927 18.2733 1.39472 18.8876 2.46359L22.8036 9.27755C23.4162 10.3436 23.4162 11.6564 22.8036 12.7225L18.8876 19.5364C18.2733 20.6053 17.1371 21.2631 15.9082 21.2631L8.09179 21.2631C6.86294 21.2631 5.7267 20.6053 5.11242 19.5364L1.19644 12.7225Z",
    stroke: "#E9BE5C",
    strokeWidth: 1.47386
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_329688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92905 10.9473L7.33307 10.5406L7.33308 10.5406C7.39668 10.4766 7.48301 10.4406 7.57313 10.4406L6.92905 10.9473ZM6.92905 10.9473C6.99468 8.09398 9.30769 5.8076 12.1575 5.8076C15.0486 5.8076 17.3873 8.16086 17.3873 11.0719C17.3873 13.983 15.0486 16.3363 12.1575 16.3363C10.7705 16.3363 9.44045 15.7818 8.45956 14.7946C8.39597 14.7306 8.30964 14.6945 8.21952 14.6945C8.12941 14.6945 8.04308 14.7306 7.97949 14.7946L7.97948 14.7946C7.91592 14.8586 7.8803 14.9453 7.88031 15.0356C7.88032 15.1259 7.91596 15.2125 7.97954 15.2765C9.08745 16.3917 10.5905 17.0184 12.1575 17.0184C15.4177 17.0184 18.0658 14.3524 18.0658 11.0719C18.0658 7.79149 15.4177 5.12553 12.1575 5.12553C8.93792 5.12553 6.31535 7.72535 6.25038 10.9494L5.84423 10.5406C5.78064 10.4766 5.69431 10.4405 5.60419 10.4405L6.92905 10.9473ZM5.36416 10.5406C5.33267 10.5723 5.30772 10.6099 5.2907 10.6512C5.27368 10.6926 5.26493 10.7369 5.26493 10.7816C5.26493 10.8263 5.27368 10.8706 5.2907 10.912C5.30772 10.9533 5.33268 10.9909 5.36417 11.0226L6.34862 12.0135L6.34862 12.0135C6.41221 12.0775 6.49854 12.1135 6.58865 12.1135C6.67876 12.1135 6.76509 12.0775 6.82868 12.0135L6.82868 12.0135L7.81314 11.0227L7.76554 10.9754L7.81314 11.0226C7.87671 10.9587 7.91235 10.872 7.91235 10.7817C7.91235 10.6914 7.87672 10.6047 7.81315 10.5407L5.36416 10.5406Z",
    fill: "#E9BE5C",
    stroke: "#E9BE5C",
    strokeWidth: 0.134205
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.157 7.29443C10.0877 7.29443 8.4043 8.98881 8.4043 11.0717C8.4043 13.1546 10.0877 14.849 12.157 14.849C14.2264 14.849 15.9098 13.1546 15.9098 11.0717C15.9098 8.98881 14.2264 7.29443 12.157 7.29443ZM12.1572 9.39645C12.6887 9.39645 13.1254 9.83603 13.1254 10.371C13.1254 10.6022 13.0406 10.8128 12.9051 10.9806C13.2058 11.1337 13.4565 11.3727 13.618 11.6698C13.7602 11.9313 13.7007 12.2458 13.5364 12.4405C13.3722 12.6352 13.1243 12.7471 12.8533 12.7471H11.4611C11.1901 12.7471 10.9422 12.6352 10.778 12.4405C10.6138 12.2458 10.5542 11.9313 10.6964 11.6697C10.8579 11.3727 11.1086 11.1337 11.4093 10.9806C11.2738 10.8128 11.1889 10.6022 11.1889 10.371C11.1889 9.83603 11.6256 9.39645 12.1572 9.39645Z",
    fill: "#E9BE5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_1213_329688",
    x: -12.1347,
    y: -12.1347,
    width: 48.2693,
    height: 46.2693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.06733
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1213_329688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1213_329688",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.86687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1213_329688"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.8684
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1213_329688",
    result: "effect3_innerShadow_1213_329688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_329688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6667,
    height: 12.7495,
    fill: "white",
    transform: "translate(5.33398 4.69714)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.725a5a71507fc76fa268c1215baba795.svg";
export { ForwardRef as ReactComponent };